import Image from "next/image";

export const Logo = () => {
    return (
        <>
            <div className={"flex flex-row px-4 pb-4 lg:py-4 items-top w-64 lg:w-full mx-auto"}>
                <div className={"flex-none basis-1/2"}>
                    <Image
                        src={"/fender.svg"}
                        priority
                        width={"0"}
                        height={"0"}
                        className="w-full pr-1"
                        alt={"Logo"}
                    ></Image>
                </div>
                <div className={"flex-none basis-1/2"}>
                    <Image
                        src={"/intelligence.svg"}
                        priority
                        width={"0"}
                        height={"0"}
                        className="w-full pl-2 pt-3.5 pr-1 opacity-50"
                        alt={"Intelligence"}
                    ></Image>
                </div>
            </div>
        </>
    );
};
